import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-900" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-b from-navy-800 to-navy-900 p-5 md:p-12 rounded-2xl border-2 border-gold-500/30 text-center relative overflow-hidden shadow-2xl" data-id="element-49">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-50"></div>

          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12 md:w-16 md:h-16 text-gold-500 mx-auto mb-4 md:mb-6" data-id="element-51">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-52"></path>
          </svg>

          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-4 md:mb-6 text-white" data-id="element-53">
            Garantía de Resultado Absoluto de 7 Días
          </h2>

          <p className="text-base md:text-lg text-gray-300 font-light leading-relaxed mb-4 md:mb-6" data-id="element-54">
            Si en una semana no has creado un video que deje en ridículo a todo
            lo que has hecho antes, envíame un correo. Te devuelvo tus $6.36
            inmediatamente y te quedas con todo por las molestias.
          </p>

          <p className="text-lg md:text-xl font-serif font-bold text-gold-500 italic" data-id="element-55">
            El riesgo es 100% mío.
          </p>
        </motion.div>
      </div>
    </section>;
}